import React from 'react';
import classNames from 'classnames';
import { Skeleton, SkeletonItem } from '@fluentui/react-components';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getAdAssetsFormShimmer = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    width: '100%',
    gap: '16px',
  },
  title: {
    marginBottom: '8px',
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '8px',
    width: '100%',
    marginBottom: '16px',

    '& div:not(:last-child)': {
      width: '100%',
    },
  },
  section: {
    width: '100%',
  },
});

export const AdAssetsFormShimmer = () => {
  const classes = useDefaultStyles(getAdAssetsFormShimmer);

  return (
    <div className={classNames('ad-assets-form-shimmer', classes.container)}>
      <div className={classes.title}>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '36px', width: '260px' }} /> </Skeleton>
      </div>
      <div className={classes.description}>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '16px', width: '100%' }} /> </Skeleton>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '16px', width: '100%' }} /> </Skeleton>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '16px', width: '320px' }} /> </Skeleton>
      </div>
      <div className={classes.section}>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '128px', width: '100%' }} /> </Skeleton>
      </div>
      <div className={classes.section}>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '224px', width: '100%' }} /> </Skeleton>
      </div>
      <div className={classes.section}>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '196px', width: '100%' }} /> </Skeleton>
      </div>
    </div>
  );
};

const getAdAssetsPreviewerShimmerStyles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    width: '400px',
    gap: '8px',
  },
  controls: {
    display: 'flex',
    gap: '8px',
  },
});

export const AdAssetsPreviewerShimmer = () => {
  const classes = useDefaultStyles(getAdAssetsPreviewerShimmerStyles);

  return (
    <div className={classNames('ad-assets-previewer-shimmer', classes.container)}>
      <div className={classes.controls}>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '36px', width: '50px' }} /> </Skeleton>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '36px', width: '65px' }} /> </Skeleton>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '36px', width: '45px' }} /> </Skeleton>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '36px', width: '55px' }} /> </Skeleton>
      </div>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '450px', width: '420px' }} /> </Skeleton>
    </div>
  );
};
